export interface StyleInfo {
	id: string;
	href: string;
	rel: 'stylesheet';
}

export function loadStyle(style: StyleInfo) {
	const head = document.getElementsByTagName('head')[0];

	let styleLink = document.querySelector<HTMLLinkElement>(style.id);
	const styleHref = window['deployUrl'] + style.href;

	if (styleLink) {
		styleLink.href = styleHref;
	} else {
		styleLink = document.createElement('link');
		styleLink.id = style.id;
		styleLink.rel = style.rel;
		styleLink.href = styleHref;

		head.appendChild(styleLink);
	}
}

export const defaultGlobalStyle = 'global-styles';
export const supportedGlobalStyles = [defaultGlobalStyle, 'global-styles-tmf'];

export function loadGlobalStyle(styleName: string) {
	if (!supportedGlobalStyles.includes(styleName)) {
		styleName = defaultGlobalStyle;
		console.warn(`Global style ${styleName} was requested, but not in list of supported styles`); // NOSONAR - warn the developer
	}

	loadStyle({
		id: 'global-styles',
		// We shouldn't need/want to have more control here, style-by-name should be enough.
		href: `${styleName}.css`,
		rel: 'stylesheet',
	});
}
